//React: Required for any React component.
//useEffect: Lets you run side effects (like initializing the engine) after the component mounts.
//useState: Used to store local state (like whether the engine has been initialized).
//useMemo: Memoizes the particles options so it doesn’t recompute on every render.
import React, { useEffect, useState, useMemo } from "react";

//Particles: The React component that renders the particles canvas.
//initParticlesEngine: Initializes the tsParticles engine for your setup.
//loadSlim: Loads a slimmed-down version of the full particles engine (faster, smaller bundle size, fewer features).
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

//functional component
const ParticlesComponent = (props) => {
  
  const [init,setInit] = useState(false);

//useEffect: runs once when the component mounts ([] dependency array means "run once").
//initParticlesEngine: initializes the engine by loading the slim version.
//await loadSlim(engine): sets up particle capabilities.
//setInit(true): marks the engine as ready.
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  //useMemo: ensures this configuration object is not recreated on every render — improving performance.
  //canvas background to transparent (so it blends with site design).
  const options = useMemo(() => ({
    
    background: {
      color: {
        value: "transparent",
      },
    },
    //for particle canvas to stay within parent container
    fullScreen: {
        enable: false,
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        //particles repel on click at dist 100 and link on hover
        onClick: { enable: true, mode: "repulse" },
        onHover: { enable: true, mode: "grab" },
      },
      modes: {
        repulse: { distance: 200 },
        grab: { distance: 140 },
      },
    },
    particles: {
        //Particle color: white.
      color: { value: "#ffffff" },
      //Draws lines between particles:
    //distance: Max distance between particles for a line to be drawn.
    //opacity/width: Styling for the lines.
      links: {
        color: "#ffffff",
        distance: 150,
        enable: true,
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 1,
        direction: "none",
        outModes: { default: "bounce" },
      },
      number: {
        value: 115,
        density: { enable: true, area: 1000 },
      },
      opacity: { value: 0.5 },
      shape: { type: "circle" },
      size: { value: { min: 1, max: 3 } },
    },
    detectRetina: true,
  }), []);
  const particlesLoaded = (container) => {
  console.log("Particles rendered", container);
};
  return <Particles id={props.id} loaded={particlesLoaded} options={options} />;
};

export default ParticlesComponent;
